import React from 'react';
import logo from 'assets/images/logo-ekz.png';

const Logo = () => {
    

    return (
         <img src={logo} alt="EKZ iTrack" width="100" />
    );
};

export default Logo;
